export default "__VITE_ASSET__Cbv7B6TN__"